﻿import React, { useState, useEffect } from 'react';

export const NumberSelectionWithLabel = (props) => {
  const wrappingClass = `single-step__section single-step__section--numberselection`;

  const clickUpHandler = () => {
    const newValue = props.value.number + 1;
    props.setValue({ ...props.value, number: newValue });
  };

  const clickDownHandler = () => {
    const newValue = props.value.number - 1;
    props.setValue({ ...props.value, number: newValue });
  };

  return (
    <div className={wrappingClass}>
      <label className="single-step__section__label">{props.text}</label>
      <div className="single-step__section__selection">
        <button className="minus" onClick={clickDownHandler} disabled={props.value.number === props.defaultMinValue || props.disabled || props.defaultMaxValue === 0}>Minus</button>
        <div className="number" ref={props.inputRef} disabled={props.disabled || props.defaultMaxValue === 0}>{props.value.number}</div>
        <button className="plus" onClick={clickUpHandler} disabled={props.value.number === props.defaultMaxValue || props.disabled || props.defaultMaxValue === 0}>Plus</button>
      </div>
      {/*{!props.disabled && props.exceededText && props.value.number === props.defaultMaxValue && <div className="validation-error validation-error--inline">{props.exceededText}</div>}*/}
      {props.children}
      {props.value.error && <div className="validation-error">{props.value.error}</div>}
    </div>
  );
}
